import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BrowsercodeHerstelWrapperComponent } from './browsercode-herstel/browsercode-herstel.wrapper.component';
import { BrowsercodeHerstelWrapperModule } from './browsercode-herstel/browsercode-herstel.wrapper.module';
import { DigicodeHerstelWrapperComponent } from './digicode-herstel/digicode-herstel.wrapper.component';
import { DigicodeHerstelWrapperModule } from './digicode-herstel/digicode-herstel.wrapper.module';
import { ErrorWrapperComponent } from './error/error.wrapper.component';
import { ErrorWrapperModule } from './error/error.wrapper.module';
import { LoginWrapperComponent } from './login/login.wrapper.component';
import { LoginWrapperModule } from './login/login.wrapper.module';
import { Auth0loginWrapperModule } from './auth0login/auth0login.wrapper.module';
import Auth0loginWrapperComponent from './auth0login/auth0login.wrapper.component';

const routes: Routes = [
    {
        path: '',
        component: LoginWrapperComponent
    },
    {
        path: 'inloggen',
        component: LoginWrapperComponent
    },
    {
        path: 'auth0inloggen',
        component: Auth0loginWrapperComponent
    },
    {
        path: 'inloggen/auth0inloggen',
        component: Auth0loginWrapperComponent
    },
    {
        path: 'inloggegevens',
        component: DigicodeHerstelWrapperComponent
    },
    {
        path: 'browsercode-vergeten',
        component: BrowsercodeHerstelWrapperComponent
    },
    {
        path: 'error',
        component: ErrorWrapperComponent
    },
    {
        path: '**',
        redirectTo: ''
    }
];

@NgModule({
    imports: [
        DigicodeHerstelWrapperModule,
        ErrorWrapperModule,
        BrowsercodeHerstelWrapperModule,
        LoginWrapperModule,
        Auth0loginWrapperModule,
        RouterModule.forRoot(routes, { useHash: false })
    ],
    exports: [RouterModule]
})
export class MijnLoginRouterModule {}
